import { Space, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import React from 'react';

import { useAppSelector } from 'shared/lib';
import { SubHeading } from 'shared/ui/SubHeading';

import { seoH1Selector, seoSubHeadingSelector } from 'entities/metadata';

import styles from './HeroHeadingBlock.module.scss';

export const HeroHeadingBlock = () => {
  const isMobile = useIsMobile();
  const headingText = useAppSelector(seoH1Selector);
  const subHeadingText = useAppSelector(seoSubHeadingSelector);

  return (
    <Space
      direction="vertical"
      size={isMobile ? 8 : 20}
      className={styles.headingBlock}
    >
      <Typography.Heading
        level={2}
        as="h1"
      >
        {headingText}
      </Typography.Heading>
      <SubHeading
        subHeadingText={subHeadingText}
        className={styles.subtitleText}
      />
    </Space>
  );
};
